var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvitationEmptyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.89216 18.6301C2.84816 18.2821 2.83816 17.7201 3.91216 17.3621L42.0862 4.63808C43.1442 4.28608 43.7502 4.87808 43.4542 5.91408L32.5462 44.0861C32.2462 45.1441 31.6362 45.1801 31.1882 44.1761L24.0002 28.0001L36.0002 12.0001L20.0002 24.0001L3.89216 18.6301Z",
    fill: "#D4D3D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvitationEmptyIcon);
export default __webpack_public_path__ + "static/media/invitation_empty_icon.2e9bc8a09bbbc12c271b5fff9434432f.svg";
export { ForwardRef as ReactComponent };